import Lottie from 'lottie-web';
import React, { useEffect, useRef, useState } from 'react';

/**
 * Lottie 애니메이션 경로 리스트
 */
const lottieList = [
  { id: 'THUMBS_UP', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-thumbs-up.json' },
  { id: 'CLAP_HAND', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-clapping-hands.json' },
  { id: 'HUNDRED_POINT', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-hundred-points.json' },
  { id: 'OK', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-ok-hand.json' },
  { id: 'PARTY_POPPER', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-party-popper.json' },
  { id: 'SMILE_WITH_HEART_EYES', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-smiling-face-with-heart-eyes.json' },
  { id: 'FIRE', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-fire.json' },
  { id: 'TWO_HEARTS', path: 'https://static.wehago.com/imgs/rtc/reaction/emoji-two-hearts.json' },
];

interface LottieEmojiProps {
  senderName: string;
  type: string;
  color: string;
  left: number;
}

const LottieEmoji: React.FC<LottieEmojiProps> = ({ senderName, type, color, left }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [leftPosition,] = useState(left)

  useEffect(() => {
    // 1. 현재 type에 맞는 데이터 찾기
    const emojiData = lottieList.find((item) => item.id === type);

    if (!emojiData || !containerRef.current) return;

    // 2. 애니메이션 로드
    const anim = Lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'canvas',
      loop: false,
      autoplay: true,
      path: emojiData.path,
    });

    // 3. 언마운트 시 정리 (메모리 누수 방지)
    return () => anim.destroy();
  }, [type]);

  return (
    <div 
      className="rtc_profileEmoji_new rtc_profileEmoji_active" 
      style={{ 
        left: `${leftPosition}%`,
        zIndex: 1203,
        position: 'absolute',
      }}
    >
      <div className="rtc_profileEmoji_newLottie">
        <div
          ref={containerRef}
          className="lottieBox"
          style={type === 'PARTY_POPPER' 
            ? { position: 'absolute', bottom: 0, left: -74, width: 204, height: 204 } 
            : { width: 56, height: 56 }
          }
        />
      </div>
      <span className="rtc_profileEmoji_sender" style={{ background: color }}>
        <span className="rtc_profileEmoji_senderText">{senderName}</span>
      </span>
    </div>
  );
};

export default LottieEmoji;
